import * as _ from 'lodash';
import { Component, OnInit, OnDestroy, AfterViewChecked, Input, OnChanges, SimpleChanges, Output, EventEmitter } from "@angular/core";

import { Map, View, Feature } from 'ol';
import { defaults as defaultControls } from 'ol/control';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import { OSM, Vector as VectorSource, TileWMS } from 'ol/source';
import { intersects } from 'ol/extent';
import { Point, Polygon } from 'ol/geom';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';
import { Draw, Modify, Snap, Select } from 'ol/interaction';
import { click } from 'ol/events/condition';
import GeoJSON from 'ol/format/GeoJSON';

import { Ouvrage } from '../../../entities/ouvrage/ouvrage.model';
import { ApiService } from 'src/app/shared/service/api.service';
import { Adresse } from '../../../entities/adresse/adresse.model';
import { Declaration } from 'src/app/entities/declaration/declaration.model';
import { CommuneService } from 'src/app/entities/commune/commune.service';
import { LexModeObtentionXY } from 'src/app/entities/lex-mode-obtention-xy/lex-mode-obtention-xy.model';
import { LexTypeSaisieCoor } from 'src/app/entities/lex-type-saisie-coor/lex-type-saisie-coor.model';
import { LexModeObtentionZ } from 'src/app/entities/lex-mode-obtention-z/lex-mode-obtention-z.model';
import { LexSystemeReferenceSpatial } from 'src/app/entities/lex-systeme-reference-spatial/lex-systeme-reference-spatial.model';
import { LexTypeLocalisation } from 'src/app/entities/lex-type-localisation/lex-type-localisation.model';
import { LexTypeSaisieCoorService } from 'src/app/entities/lex-type-saisie-coor/lex-type-saisie-coor.service';
import { LexModeObtentionXYService } from 'src/app/entities/lex-mode-obtention-xy/lex-mode-obtention-xy.service';
import { LexModeObtentionZService } from 'src/app/entities/lex-mode-obtention-z/lex-mode-obtention-z.service';
import { LexTypeLocalisationService } from 'src/app/entities/lex-type-localisation/lex-type-localisation.service';
import { LexSystemeReferenceSpatialService } from 'src/app/entities/lex-systeme-reference-spatial/lex-systeme-reference-spatial.service';
import { Commune } from 'src/app/entities/commune/commune.model';
import { ListOuvrage } from 'src/app/entities/ouvrage/listouvrage.model';
import { Acteur } from 'src/app/entities/acteur/acteur.model';
import { OuvrageService } from 'src/app/entities/ouvrage/ouvrage.service';


/**
 * Composant d'affichage de la carte OpenLayers
 */
@Component({
  selector: 'ol-map',
  styleUrls: ['./ol-map.component.scss'],
  templateUrl: './ol-map.component.html'
})

export class OlMapComponent implements OnInit, AfterViewChecked, OnChanges, OnDestroy {

  address:string;

  @Input() declaration: Declaration;

  @Input() declarationOuvrages: ListOuvrage;

  @Input() tick:number;

  @Input() isSame:boolean = true;

  @Output() tock: EventEmitter<number> = new EventEmitter();

  /**
   * Objet Ol Map
   */

  private _map: Map = null;

  private ouvrageEnCoursModificationX: number;
  private ouvrageEnCoursModificationY: number;
  private ouvrageEnCoursUuid: string;
  private defaultLexmethodesxy: LexModeObtentionXY;
  private defaultTypeSaisieCoord: number;
  private defaultSrsId: number;
  private defaultSrsLibelle: string;
  private defaultTypeLocalisationId: number;

  // les differents lexiques
  lextypesaisiecoor: LexTypeSaisieCoor[];
  lexmethodesxy: LexModeObtentionXY[];
  lexmethodesz: LexModeObtentionZ[];
  lexsrs: LexSystemeReferenceSpatial[];
  lextypelocalisation: LexTypeLocalisation[];

  /**
   * Source OL contenant
  */
  parcellesSource: VectorSource;
  pointsSource: VectorSource;
  ouvragesSource: VectorSource;
  ouvragesLayer: VectorLayer;
  source : VectorSource;
  pointsLayer: VectorLayer;
  parcellesLayer: VectorLayer;
  draw : Draw;

  layerSwitcherLayers:any[] = [];

  dromLayer: VectorLayer;
  dromLayers:any[] = [];

  // Variables nécessaires à l'affichage des coordonnées/bouton "valider" dans le formulaire ouvrageForm
  coord_ok: boolean = true;
  @Output() coord_valide_child: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private lexTypeSaisieCoorService: LexTypeSaisieCoorService,
    private lexModeObtentionXYService: LexModeObtentionXYService,
    private lexModeObtentionZService: LexModeObtentionZService,
    private lexTypeLocalisationService: LexTypeLocalisationService,
    private lexSystemeReferenceSpatialService:LexSystemeReferenceSpatialService,
    private ouvrageService: OuvrageService,
    private ouvrageDeclarationService: ApiService ,
    private communeService: CommuneService,
    ) {
    }

  ngOnInit() {
    this.source = new VectorSource({wrapX: false});
    this.draw = new Draw({
      source: this.source,
      type: 'Point'
    });

    this.lexTypeLocalisationService.query()
      .subscribe((res) => {
        this.lextypelocalisation = res;
        this.defaultTypeLocalisationId = _.find(this.lextypelocalisation, ["code", 0]).id;
      });

    this.lexTypeSaisieCoorService.query()
    .subscribe((res) => { this.lextypesaisiecoor = res;
      this.defaultTypeSaisieCoord = _.find(this.lextypesaisiecoor, ['code','2']).id;
    });

    this.lexModeObtentionXYService.query()
      .subscribe((res) => {
        this.lexmethodesxy = res;
        this.defaultLexmethodesxy = _.find(this.lexmethodesxy, ["code", '1']);
    });

    this.lexModeObtentionZService.query()
      .subscribe((res) => { this.lexmethodesz = res; });

    this.ouvragesSource = new VectorSource();

    this.ouvrageService.currentUser({
          statutIds: '',
          id: '',
          name: ''
        }).subscribe(res => {
          const featureList = new Array<Feature>();
          res.forEach(ouvrage => {
            if (ouvrage.geom){
              let infobulle = "Déclaration : "+ ouvrage.declarationId +"<br/>Ouvrage : "+ouvrage.nomUsuel+"<br/>Statut : "+ouvrage.statutLibelle;
              let feature = new Feature({
                'geometry': new Point([ouvrage.geom.coordinates[0], ouvrage.geom.coordinates[1]]),
                dataProjection: 'EPSG: 4326',
                featureProjection: 'EPSG: 4326',
                name: infobulle,
                class: ouvrage.statutId,
                declaration: ouvrage.declarationId
              });
              featureList.push(feature);
            }
          });
          this.ouvragesSource.addFeatures(featureList);
        });


    this._createMap();
    this.lexSystemeReferenceSpatialService.query()
    .subscribe((res) => {
      this.lexsrs = res;
      this.defaultSrsId = _.find(this.lexsrs, ["epsg", 4326]).id;
      this.defaultSrsLibelle = _.find(this.lexsrs, ["epsg", 4326]).libelle;
    });

  }


  ngAfterViewChecked (){
    this._map.updateSize();
    this.refreshPointList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let propName in changes) {
      if(propName == 'tick') {
        if(this.tick >0 ) this.refreshPointList();
      }
    }
  }

  ngOnDestroy() {
    this._map = null;
  }

  private getId(item:any) {
    return item.id;
  }

  findByAddress() {
    if(this.address) {
      this.ouvrageDeclarationService.getAdresseByName(this.address).subscribe((data:any)=> {
        if(data != null) {
          if(data.features[0].properties.type == "street" || data.features[0].properties.type == "housenumber") {
            this._map.getView().setCenter([data.features[0].geometry.coordinates[0],data.features[0].geometry.coordinates[1]]);
            this._map.getView().setZoom(19);
          } else {
            this.communeService.findByCoordinates(data.features[0].geometry.coordinates[0], data.features[0].geometry.coordinates[1]).subscribe((commune) => {
              let geometry = (new GeoJSON()).readGeometry(commune.geom);
              this._map.getView().fit(geometry.getExtent());
            });
          }
        }
      });
    }
  }

   /**
   * Crée la carte OpenLayers
   */
  private _createMap(): void {

    this.pointsSource = new VectorSource();
    this.pointsLayer = new VectorLayer({
        duplos: {
          name: 'DrawLayer'
        },
        title: 'Ouvrages déclarés',
        source: this.pointsSource,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new Stroke({
            color: '#ffcc33',
            width: 2
          }),
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({
              color: '#ffcc33'
            })
          })
        })
    });
    this.parcellesSource = new VectorSource();
    this.parcellesLayer = new VectorLayer({
        parcelles: {
          name: 'ParcelleLayer'
        },
        title: 'Cadastre',
        source: this.parcellesSource,
        style: new Style({
          stroke: new Stroke({
            color: '#000',
            width: 1
          })
        }),
      });

    this.ouvragesLayer = new VectorLayer({
        ouvrages: {
          name: 'OuvragesLayer'
        },
        title: 'Mes Ouvrages',
        source: this.ouvragesSource,
        style: function(feature) {
          let style;
          let statut = feature.get('class');
          switch(statut) {
            case 1950: {
              style = new Style({
                image: new CircleStyle({
                  radius: 7,
                  fill: new Fill({
                    color: 'black'
                  })
                })
              });
              break;
            }
            case 1900: {
              style = new Style({
                image: new CircleStyle({
                  radius: 7,
                  fill: new Fill({
                    color: 'green'
                  })
                })
              })
              break;
            }
            case 1850: {
              style = new Style({
                image: new CircleStyle({
                  radius: 7,
                  fill: new Fill({
                    color: 'blue'
                  })
                })
              })
              break;
            }
            case 1800: {
              style = new Style({
                image: new CircleStyle({
                  radius: 7,
                  fill: new Fill({
                    color: 'yellow'
                  })
                })
              })
              break;
            }
          }
          return style;
        }
    });

    let osmLyr = new TileLayer({
      title: 'Open Street Map',
      source: new OSM(),
      type: 'base'
    });

    let bssLayer = new TileLayer({
      title: 'Ouvrages BSS',
      source: new TileWMS({
        url: 'https://mapsref.brgm.fr/wxs/infoterre/catalogue',
        params: {'LAYERS': ['BSS_TOTAL', 'BSS_SEMIS_2', 'BSS_SEMIS_1', 'BSS_SEMIS_0']}
      }),
      visible: false,
      type: 'base'
    });

    let orthoLayer = new TileLayer({
      title: 'OrthoPhoto',
      source: new TileWMS({
        url: 'https://mapsref.brgm.fr/wxs/refcom-brgm/refign',
        params: {
          'LAYERS': 'ORTHO',
          'TRANSPARENT': 'TRUE',
          'SERVICE': 'WMS',
          'VERSION': '1.1.1',
          'REQUEST': 'GetMap',
          'SRS': 'EPSG:4326',
          'FORMAT': 'image/png'}
      }),
      type: 'base'
    });

    this.layerSwitcherLayers.push({olLayer: this.ouvragesLayer, title: this.ouvragesLayer.get('title'), visible: this.ouvragesLayer.getVisible(), id: 'ouvrages'});
    this.layerSwitcherLayers.push({olLayer: this.parcellesLayer, title: this.parcellesLayer.get('title'), visible: this.parcellesLayer.getVisible(), id: 'cadastre'});
    //this.layerSwitcherLayers.push({olLayer: osmLyr, title: osmLyr.get('title'), visible: osmLyr.getVisible(), id: 'osm'});
    this.layerSwitcherLayers.push({olLayer: bssLayer, title: bssLayer.get('title'), visible: bssLayer.getVisible(), id: 'infoterre'});
    this.layerSwitcherLayers.push({olLayer: orthoLayer, title: orthoLayer.get('title'), visible: orthoLayer.getVisible(), id: 'orthophoto'});

    let guadeloupeLayer = new TileLayer({
      title: 'Guadeloupe',
      icon: '../../../../assets/images/drom/Guadeloupe.jpg',
      source: new TileWMS({
        url: 'https://mapsref.brgm.fr/wxs/refcom-brgm/refign',
        params: {
          'LAYERS': 'GUADELOUPE',
          'TRANSPARENT': 'TRUE',
          'SERVICE': 'WMS',
          'VERSION': '1.1.1',
          'REQUEST': 'GetMap',
          'CODE': 'EPSG:2970',
          'SRS': 'RRAF 1991',
          'FORMAT': 'image/png'}
      }),
      type: 'base'
    });

    let martiniqueLayer = new TileLayer({
      title: 'Martinique',
      icon: '../../../../assets/images/drom/Martinique.jpg',
      source: new TileWMS({
        url: 'https://mapsref.brgm.fr/wxs/refcom-brgm/refign',
        params: {
          'LAYERS': 'MARTINIQUE',
          'TRANSPARENT': 'TRUE',
          'SERVICE': 'WMS',
          'VERSION': '1.1.1',
          'REQUEST': 'GetMap',
          'CODE': 'EPSG:2973',
          'SRS': 'RRAF 1991',
          'FORMAT': 'image/png'}
      }),
      type: 'base'
    });

    let guyaneLayer = new TileLayer({
      title: 'Guyane',
      icon: '../../../../assets/images/drom/Guyane.jpg',
      source: new TileWMS({
        url: 'https://mapsref.brgm.fr/wxs/refcom-brgm/refign',
        params: {
          'LAYERS': 'GUIANE',
          'TRANSPARENT': 'TRUE',
          'SERVICE': 'WMS',
          'VERSION': '1.1.1',
          'REQUEST': 'GetMap',
          'CODE': 'EPSG:2972',
          'SRS': 'RGFG95',
          'FORMAT': 'image/png'}
      }),
      type: 'base'
    });

    let mayotteLayer = new TileLayer({
      title: 'Mayotte',
      icon: '../../../../assets/images/drom/Mayotte.jpg',
      source: new TileWMS({
        url: 'https://mapsref.brgm.fr/wxs/refcom-brgm/refign',
        params: {
          'LAYERS': 'MAYOTTE',
          'TRANSPARENT': 'TRUE',
          'SERVICE': 'WMS',
          'VERSION': '1.1.1',
          'REQUEST': 'GetMap',
          'CODE': 'EPSG:4471',
          'SRS': 'RGM04',
          'FORMAT': 'image/png'}
      }),
      type: 'base'
    });

    let reunionLayer = new TileLayer({
      title: 'Réunion',
      icon: '../../../../assets/images/drom/Réunion.jpg',
      source: new TileWMS({
        url: 'https://mapsref.brgm.fr/wxs/refcom-brgm/refign',
        params: {
          'LAYERS': 'REUNION',
          'TRANSPARENT': 'TRUE',
          'SERVICE': 'WMS',
          'VERSION': '1.1.1',
          'REQUEST': 'GetMap',
          'CODE': 'EPSG:2975',
          'SRS': 'RGR92',
          'FORMAT': 'image/png'}
      }),
      type: 'base'
    });


    this.dromLayers.push({olLayer: guadeloupeLayer, title: guadeloupeLayer.get('title'), icon: guadeloupeLayer.get('icon'), visible: guadeloupeLayer.getVisible(), id: 'guadeloupe'});
    this.dromLayers.push({olLayer: martiniqueLayer, title: martiniqueLayer.get('title'), icon: martiniqueLayer.get('icon'), visible: martiniqueLayer.getVisible(), id: 'martinique'});
    this.dromLayers.push({olLayer: guyaneLayer, title: guyaneLayer.get('title'), icon: guyaneLayer.get('icon'), visible: guyaneLayer.getVisible(), id: 'guyane'});
    this.dromLayers.push({olLayer: mayotteLayer, title: mayotteLayer.get('title'), icon :mayotteLayer.get('icon'), visible: mayotteLayer.getVisible(), id: 'mayotte'});
    this.dromLayers.push({olLayer: reunionLayer, title: reunionLayer.get('title'), icon: reunionLayer.get('icon'), visible: reunionLayer.getVisible(), id: 'reunion'});


    this._map = new Map({
      controls: defaultControls(),
      view: new View({
        projection: 'EPSG:4326',
        center: [2.4609, 46.6061],
        zoom: 7
      }),
      layers: [
        osmLyr,
        orthoLayer,
        bssLayer,
        this.ouvragesLayer,
        this.pointsLayer,
        this.parcellesLayer
      ],
      target: 'map'
    });

    let select = new Select({
      condition: click
    });

    select.on('select', event => this.onSelectPoint(event))
    //this._map.addInteraction(select);

    this.draw = new Draw({
      source: this.pointsSource,
      type: 'Point'
    });
    this.draw.on('drawend', event => this.onDrawPoint(event));
    //this._map.addInteraction(this.draw);

    let snap = new Snap({source: this.pointsSource});
    this._map.addInteraction(snap);

    let modify = new Modify({source: this.pointsSource});
    modify.on('modifystart', event => this.onModifyPointStart(event));
    modify.on('modifyend', event => this.onModifyPointEnd(event));
    this._map.addInteraction(modify);

    this._map.on('moveend', (event) => this.onZoom(event));
  }

  toggleLayer(layer:any) {
    layer.olLayer.setVisible(layer.visible);
  }

  goToDrom(drom:any) {
    switch (drom.id) {
      case 'guadeloupe':
        this._map.getView().setCenter([-61.551006, 16.265090]);
        this._map.getView().setZoom(10);
        break;

      case 'martinique':
        this._map.getView().setCenter([-60.993182, 14.651985]);
        this._map.getView().setZoom(10);
        break;

      case 'guyane':
        this._map.getView().setCenter([-53.160926, 3.809585]);
        this._map.getView().setZoom(7);
        break;

      case 'mayotte':
        this._map.getView().setCenter([45.155090, -12.819234]);
        this._map.getView().setZoom(11);
        break;

      case 'reunion':
        this._map.getView().setCenter([55.546996, -21.111722]);
        this._map.getView().setZoom(10);
        break;
    
      default:
        break;
    }
  }

  /**
   * Event lorsqu'un point est selectionné
   */
  private onSelectPoint(e): void {

  }

  /**
   * Event lorsqu'un point est dessiné
   */
  private onDrawPoint(e): void {

    this._map.removeInteraction(this.draw);

    // Vérifie si la déclaration doit contenir 1 ou plusieurs points

    if(this.declarationOuvrages.ouvrages.length >= 20){
      return;
    }

    if ((this.declarationOuvrages == null)
    || (this.declarationOuvrages && this.declaration.plusieursOuvrages)
    || (this.declarationOuvrages && !this.declaration.plusieursOuvrages && this.declarationOuvrages.ouvrages.length == 0)){
      let feature = e.feature;
      let ouvrage = new Ouvrage();
      ouvrage.x = _.floor(feature.getGeometry().getCoordinates()[0],5);
      ouvrage.y = _.floor(feature.getGeometry().getCoordinates()[1],5);

      const unicity = _.find(this.declarationOuvrages.ouvrages, {"x": ouvrage.x, "y": ouvrage.y});
      if(unicity) {
        this.refreshPointList();
      } else {
        ouvrage.geom = (new GeoJSON()).writeFeatureObject(feature.clone())['geometry'];

        ouvrage.nomUsuel = "";
        ouvrage.typeSaisieCoorId = this.defaultTypeSaisieCoord;
        ouvrage.adresse = new Adresse();
        ouvrage.adresse.pays = "France";
        ouvrage.modeXYId = this.defaultLexmethodesxy.id;
        ouvrage.modeXYLibelle = this.defaultLexmethodesxy.libelle;
        ouvrage.precisionXYId = this.defaultLexmethodesxy.precisionXYId;
        ouvrage.precisionXYLibelle = this.defaultLexmethodesxy.precisionXYLibelle;
        ouvrage.srsId = this.defaultSrsId;
        ouvrage.srsLibelle = this.defaultSrsLibelle;
        ouvrage.typeLocalisationId = this.defaultTypeLocalisationId;
        if(this.declarationOuvrages.ouvrages.length > 0 && this.isSame) {
          this.clone(ouvrage);
        } else {
          ouvrage.acteurMoe = new Acteur();
          ouvrage.acteurProprio = new Acteur();
          ouvrage.acteurForeur = new Acteur();
        }
        this.declarationOuvrages.ouvrages.push(ouvrage);
        this.tock.emit(this.tick);
        this.refreshPointList();

        this.coord_ok = true;
        this.coord_valide_child.emit(this.coord_ok);

        this.ouvrageDeclarationService.getCadastreByCoordinates(ouvrage.x, ouvrage.y).subscribe((data:any) => {
          if (data?.features[0]?.properties) {
            ouvrage.numSection = data.features[0].properties.section;
            ouvrage.numFeuille = data.features[0].properties.feuille;
            ouvrage.numParcelle = data.features[0].properties.numero;
          }
          this.findZByCoordinates(ouvrage);
          
        },
        (error) => this.findZByCoordinates(ouvrage));

        
      }
    } /*else {
      this._map.addInteraction(this.draw);
    }*/
  }

  clone(ouvrageToClone:Ouvrage) {
    let ouvrage: Ouvrage = this.declarationOuvrages.ouvrages[0];
    ouvrageToClone.acteurMoe = _.cloneDeep(ouvrage.acteurMoe);
    ouvrageToClone.acteurMoeId = _.clone(ouvrage.acteurMoeId);
    ouvrageToClone.acteurProprio = _.cloneDeep(ouvrage.acteurProprio);
    ouvrageToClone.acteurProprioId = _.clone(ouvrage.acteurProprioId);
    ouvrageToClone.acteurForeur = _.cloneDeep(ouvrage.acteurForeur);
    ouvrageToClone.acteurForeurId = _.clone(ouvrage.acteurForeurId);
    ouvrageToClone.longeur = _.clone(ouvrage.longeur);
    ouvrageToClone.diametre = _.clone(ouvrage.diametre);
    ouvrageToClone.natureOuvrageId = _.clone(ouvrage.natureOuvrageId);
    ouvrageToClone.natureOuvrageLibelle = _.clone(ouvrage.natureOuvrageLibelle);
    ouvrageToClone.directionId = _.clone(ouvrage.directionId);
    ouvrageToClone.directionLibelle = _.clone(ouvrage.directionLibelle);
    ouvrageToClone.azimut = _.clone(ouvrage.azimut);
    ouvrageToClone.pendage = _.clone(ouvrage.pendage);
    ouvrageToClone.presenceMargelle = _.clone(ouvrage.presenceMargelle);
    ouvrageToClone.conformeNorme = _.clone(ouvrage.conformeNorme);
    ouvrageToClone.prelevement = _.clone(ouvrage.prelevement);
    ouvrageToClone.debit = _.clone(ouvrage.debit);
    ouvrageToClone.reseauInterne = _.clone(ouvrage.reseauInterne);
    ouvrageToClone.rejetPluviales = _.clone(ouvrage.rejetPluviales);
    ouvrageToClone.rejetUsees = _.clone(ouvrage.rejetUsees);
    ouvrageToClone.codeNappe = _.clone(ouvrage.codeNappe);
    ouvrageToClone.natureNappe = _.clone(ouvrage.natureNappe);
    ouvrageToClone.nomNappe = _.clone(ouvrage.nomNappe);
    ouvrageToClone.commentaireNappe = _.clone(ouvrage.commentaireNappe);
  }

  private findZByCoordinates(ouvrage:Ouvrage) {
    this.ouvrageDeclarationService.getZByCoordinates(ouvrage.x, ouvrage.y).subscribe((res:any) => {
      if(res.elevations[0]!=null) {
        ouvrage.zcalc = res.elevations[0];
        let methodeZ = _.find(this.lexmethodesz, ['code', '1']);
        ouvrage.modeZCalcId = methodeZ.id;
        ouvrage.modeZCalcLibelle = methodeZ.libelle;
        ouvrage.precisionZCalcId = methodeZ.precisionZId;
        ouvrage.precisionZCalcLibelle = methodeZ.precisionZLibelle;
      }
      this.getAdresse(ouvrage);
    },
    (error)=> this.getAdresse(ouvrage));
  }

  getMairieMail(ouvrage:Ouvrage, insee: string){
    /*this.ouvrageDeclarationService.getMairieMail(insee).subscribe(
      (data:any) => {
        console.log(data);
        //if (data && data.organismes){
          
        //}
      }
    );*/
    let data : any;   
    data = [{"nom":"Orléans","insee":"45234","codePostal":null,"organismes":[{"nom":"Direction régionale de l'environnement, de l'aménagement et du logement (DREAL) - Unité territoriale - Loiret","editeurSource":"Direction de l'information légale et administrative (Première ministre)","externalId":"216c30f9-0b2b-4d98-b1ee-c25614c55abf","inseeCode":null,"dateMiseAjour":"10-12-2018","pivotLocal":"dreal_ut","openingDaysDTO":[{"from":"Lundi","to":"Vendredi","note":null,"openingHours":[{"from":"08:30","to":"12:00"},{"from":"14:00","to":"16:00"}]}],"serviceDTOs":null,"adresseDTOs":[{"nom":"Orléans Cedex 2","label":"3 rue du Carbone","lignes":["3 rue du Carbone"],"numeroVoie":"3 rue du Carbone","typeVoie":null,"complement":null,"type":"géopostale","pays":null,"codePostal":"45072","accessibility":null,"accessibilityType":null,"serviceDistribution":null,"longitude":1.9245,"latitude":47.8154,"precision":null}],"commentaire":null,"mailEditeur":null,"idPresta":null,"coordonneesNumDTO":{"telephone":"02 38 25 01 20","coutTelephone":null,"fax":"02 38 63 84 44","url":"http://www.centre.developpement-durable.gouv.fr","sve":"http://www.developpement-durable.gouv.fr/Formulaire-de-saisie-de-l.html","email":"http://www.centre.developpement-durable.gouv.fr/contact-a433.html","versionMobile":null}},{"nom":"Mairie - Orléans","editeurSource":"Direction de l'information légale et administrative (Première ministre)","externalId":"40be00b0-eac8-4016-af3f-2516a475947c","inseeCode":null,"dateMiseAjour":"08-03-2021","pivotLocal":"mairie","openingDaysDTO":[{"from":"Lundi","to":"Jeudi","note":null,"openingHours":[{"from":"08:30","to":"17:30"}]},{"from":"Vendredi","to":"Vendredi","note":null,"openingHours":[{"from":"08:30","to":"17:00"}]},{"from":"Samedi","to":"Samedi","note":null,"openingHours":[{"from":"09:00","to":"12:00"}]}],"serviceDTOs":null,"adresseDTOs":[{"nom":"Orléans Cedex 1","label":"1 place de l'Étape","lignes":["1 place de l'Étape"],"numeroVoie":"1 place de l'Étape","typeVoie":null,"complement":null,"type":"géopostale","pays":null,"codePostal":"45040","accessibility":null,"accessibilityType":"ACC","serviceDistribution":null,"longitude":1.9084485,"latitude":47.90322,"precision":null}],"commentaire":null,"mailEditeur":null,"idPresta":null,"coordonneesNumDTO":{"telephone":"02 38 79 22 22","coutTelephone":null,"fax":null,"url":"http://www.orleans-metropole.fr","sve":null,"email":"info@ville-orleans.fr","versionMobile":null}}],"urlDemarches":[]}];
    if (data[0]?.organismes[1]){
        //console.log(data[0].organismes[1].coordonneesNumDTO.email);
        this.declaration.communes[0].email = data[0].organismes[1].coordonneesNumDTO.email;
        console.log(this.declaration.communes[0].email);
    }
    //(error) => console.log("erreur mail maire");
  }

  private getAdresse(ouvrage:Ouvrage) {
    this.ouvrageDeclarationService.getAdresseByCoordinate(ouvrage.x, ouvrage.y).subscribe(
      (data: any) => {
          if (data && data.features && data.features[0] && data.features[0].properties) {
            ouvrage.adresse.codePostal = data.features[0].properties.postcode;
            ouvrage.adresse.communeInseeCom = data.features[0].properties.citycode;
            ouvrage.adresse.nomVoie = data.features[0].properties.name;
            ouvrage.adresse.numeroVoie = data.features[0].properties.housenumber;
            if(ouvrage.adresse.communeInseeCom) {
              this.communeService.find(ouvrage.adresse.communeInseeCom).subscribe((commune) =>
              {
                ouvrage.adresse.commune = commune;
                ouvrage.adresse.codePostal = commune.codePostal.substr(0,5);
                this.getMairieMail(ouvrage, data.features[0].properties.citycode);
              });
            }
          } else {
            this.getCommuneByCoordinates(ouvrage);
          }
      },
      (error) => this.getCommuneByCoordinates(ouvrage));
  }

  private getCommuneByCoordinates(ouvrage:Ouvrage) {
    this.communeService.findByCoordinates(ouvrage.x, ouvrage.y).subscribe((commune) => {
      ouvrage.adresse.commune = commune;
      ouvrage.adresse.codePostal = commune.codePostal;
      ouvrage.adresse.communeInseeCom = commune.inseeCom;
    });
  }

  /**
   * Event lorsqu'un point va être modifié
   */
  private onModifyPointStart(e): void {
    let features = this._map.getFeaturesAtPixel(e.target.lastPixel_,{
      layerFilter: function(layerCandidate){

        return (layerCandidate.values_.duplos) ;
      }
    });
    this.ouvrageEnCoursUuid = features[0].ol_uid;
    this.ouvrageEnCoursModificationX = _.floor(features[0].getGeometry().getCoordinates()[0],5);
    this.ouvrageEnCoursModificationY = _.floor(features[0].getGeometry().getCoordinates()[1],5);
  }

  /**
   * Event lorsqu'un point est modifié
   */
  private onModifyPointEnd(e): void {
    let coords = null;
    e.features.forEach(feature => {
      if (feature.ol_uid == this.ouvrageEnCoursUuid){
        coords = feature.getGeometry().getCoordinates();
      }
    });

    this.coord_ok = true;
    this.coord_valide_child.emit(this.coord_ok);

    this.declarationOuvrages.ouvrages.forEach(( ouvrage) => {
      if (ouvrage.x == this.ouvrageEnCoursModificationX && ouvrage.y == this.ouvrageEnCoursModificationY) {
          ouvrage.x = _.floor(coords[0],5);
          ouvrage.y = _.floor(coords[1],5);
          this.getAdresse(ouvrage);
      }
    });
  }

  refreshPointList() {
    const featureList = new Array<Feature>();

    if (this.pointsSource){
      this.pointsSource.clear(true);
      if (this.declarationOuvrages.ouvrages.length > 0){
        this.declarationOuvrages.ouvrages.forEach(ouvrage => {
          if (ouvrage.geom) {
            let feature = new Feature({
              'geometry': new Point([ouvrage.geom.coordinates[0], ouvrage.geom.coordinates[1]]),
              dataProjection: 'EPSG: 4326',
              featureProjection: 'EPSG: 4326'
            });
            if(!ouvrage.geom) {
              ouvrage.geom = (new GeoJSON()).writeFeatureObject(feature.clone())['geometry'];
            }
            featureList.push(feature);
          }
        });
        if (featureList.length > 0){
          this.pointsSource.addFeatures(featureList);
        }
        if(this.declaration.plusieursOuvrages) {
          if(!this._map.getInteractions().getArray().includes(this.draw))
            this._map.addInteraction(this.draw);
        }
      } else {
        if(!this._map.getInteractions().getArray().includes(this.draw))
          this._map.addInteraction(this.draw);
      }
    }
  }

  private onZoom(e): void {
    let zoom = this._map.getView().getZoom();
    this.parcellesSource.clear(true);
    if(zoom>16) {
      let extentMap = this._map.getView().calculateExtent(this._map.getSize());
      this.communeService.findByBBox(extentMap).subscribe((res)=> {
        let communes:Commune[] = res;
        if(communes !=null) {
          communes.forEach((commune:Commune) => {
            if(commune.inseeCom=="75056" || commune.inseeCom=="13055" || commune.inseeCom=="69123")
            {
              this.ouvrageDeclarationService.getArrondissements(commune.inseeDep).subscribe((arrondissements:any) => {
                let arr:string[] = [];
                arrondissements.records.forEach((arrondissement) => {
                  let shape = (new GeoJSON()).readGeometry(arrondissement.fields.geo_shape);
                  if(intersects(extentMap,shape.getExtent())) {
                    arr.push(arrondissement.fields.code_insee);
                  }
                });
                arr.forEach((a) => this.createFeaturesParcelle(a, extentMap));
              });
            } else {
              this.createFeaturesParcelle(commune.inseeCom, extentMap);
            }
          });
        }
      })
    }
  }

  private createFeaturesParcelle(code_insee, extent) {
    this.ouvrageDeclarationService.getCadastreLayer(code_insee).subscribe((featureCollection:any) => {
      const featureList = new Array<Feature>();
      featureCollection.features.forEach((feat) => {
        let feature = new Feature({
          'geometry': new Polygon(feat.geometry.coordinates),
          dataProjection: 'EPSG: 4326',
          featureProjection: 'EPSG: 4326'
        });
        if(intersects(extent,feature.getGeometry().getExtent()))
        {
          featureList.push(feature);
        }
      });
      this.parcellesSource.addFeatures(featureList);
    });
  }
}
